import {
  AtoDetalhe,
  AtoResumo,
  BoletimDetalhe,
  BoletimResumo,
  TipoAto,
  TipoBoletim,
} from '../models/boletim.model';

export const TIPOS_ATO_OPCOES: { value: TipoAto; label: string }[] = [
  { value: 'TRANSFERENCIA', label: 'Transferência' },
  { value: 'PROMOCAO', label: 'Promoção' },
  { value: 'PUNICAO', label: 'Punição' },
  { value: 'ELOGIO', label: 'Elogio' },
  { value: 'CONCLUSAO_CURSO', label: 'Conclusão de Curso' },
  { value: 'AFASTAMENTO', label: 'Afastamento' },
  { value: 'AVERBACAO', label: 'Averbação' },
  { value: 'CLASSIFICACAO', label: 'Classificação' },
  { value: 'CONCEITO_PROFISSIONAL', label: 'Conceito Profissional' },
  { value: 'OUTRO', label: 'Outro' },
];

export const TIPOS_BOLETIM_OPCOES: { value: TipoBoletim; label: string }[] = [
  { value: 'BI', label: 'Boletim Interno' },
  { value: 'BCG', label: 'Boletim do Comando Geral' },
  { value: 'BRCG', label: 'Boletim Reservado do Comando Geral' },
  { value: 'BI_RES', label: 'Boletim Interno Reservado' },
];

export const TIPOS_BOLETIM_FECHAMENTO_OPCOES: { value: TipoBoletim; label: string }[] = [
  { value: 'BI', label: 'BI — Boletim Interno' },
  { value: 'BCG', label: 'BCG — Boletim do Comando Geral' },
  { value: 'BRCG', label: 'BRCG — Boletim Reservado do CG' },
  { value: 'BI_RES', label: 'BI_RES — Boletim Interno Reservado' },
];

export function obterLabelTipoAto(tipo: TipoAto): string {
  return TIPOS_ATO_OPCOES.find(item => item.value === tipo)?.label ?? tipo;
}

export function obterLabelTipoBoletim(tipo: TipoBoletim): string {
  return TIPOS_BOLETIM_OPCOES.find(item => item.value === tipo)?.label ?? tipo;
}

export function obterOrigemPorTipoAto(tipoAto: TipoAto): string {
  if (tipoAto === 'TRANSFERENCIA') return 'movimentacao';
  if (tipoAto === 'PROMOCAO') return 'promocao';
  return 'disciplinar';
}

export function criarMockAtoDetalhe(
  resumo: AtoResumo,
  contexto: 'revisao' | 'assinatura' = 'revisao',
): AtoDetalhe {
  const label = obterLabelTipoAto(resumo.tipoAto);
  const textoBase =
    contexto === 'assinatura'
      ? `TRANSFERIR, de acordo com o Art. 10 da Lei nº 7.289/84 (Estatuto dos Policiais Militares), o militar abaixo identificado, por conveniência do serviço:\n\nMatrícula: ${resumo.matriculasAfetadas[0]}\nNome: 1º SGT PM JOÃO DOS SANTOS OLIVEIRA\n\nUPM de Origem: 1º BPM (Asa Sul)\nUPM de Destino: 2º BPM (Taguatinga)\n\nData de Vigência: ${resumo.dataVigencia}\nFundamentação Legal: Portaria PMDF 142/2023.`
      : `Texto original recebido para publicação do ato de ${label} referente à(s) matrícula(s) ${resumo.matriculasAfetadas.join(', ')}.`;

  return {
    ...resumo,
    textoOriginal: textoBase,
    textoRevisado: textoBase,
    solicitanteOrigem: obterOrigemPorTipoAto(resumo.tipoAto),
  };
}

export function criarMockBoletimDetalhe(resumo: BoletimResumo): BoletimDetalhe {
  return {
    ...resumo,
    pdfPath: `/storage/boletins/${resumo.tipo}-${resumo.numero}.pdf`,
    pdfHash: 'd7a123e-mock-sha-256-hash-of-pdf-file',
    publicadoPor: '900.123-4',
    publicadoEm: `${resumo.dataPublicacao}T17:00:00Z`,
    atos: [
      {
        id: '1',
        tipoAto: 'TRANSFERENCIA',
        matriculasAfetadas: ['10.2030.040506'],
        estado: 'PUBLICADO',
        dataVigencia: '2026-06-15',
        tipoBoletimSolicitado: resumo.tipo,
        correlationId: 'corr-1',
        criadoEm: '2026-06-08T10:15:30Z',
        paginaNoBoletim: 1,
      },
    ],
  };
}
